import { displayToast, displayFormErrors, sendAppsignalError } from "../modules/utils";

class PaymentSubscription {
  constructor(node) {
    this.element = node;

    this.formElement = this.element.querySelector(".js-payment-subscription-form");
    this.subscriptionTypeFreeInput = this.element.querySelector(".js-subscription-type-free");
    this.subscriptionTypeInputs = this.element.querySelectorAll(".js-subscription-type-input");
    this.submitButton = document.querySelector(".js-subscription-submit");

    this.initialize();
  }

  initialize() {
    this.checkSubscriptionType();

    this.subscriptionTypeInputs.forEach((input) => {
      input.addEventListener("change", () => {
        this.checkSubscriptionType();
      });
    });

    this.formElement.addEventListener("submit", (e) => {
      e.preventDefault();

      this.submitForm();
    });
  }

  checkSubscriptionType() {
    this.submitButton.disabled = this.subscriptionTypeFreeInput.checked;
  }

  submitForm() {
    fetch(this.formElement.action, {
      retries: 3,
      retryDelay: 1000,
      method: "POST",
      body: new FormData(this.formElement),
    })
      .then((response) => {
        let { status } = response;
        this.response = response;
        this.formStatus = status;

        if (this.formStatus === 200 || this.formStatus === 422) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        if (this.formStatus === 200) {
          window.location.href = data.url;
        }
        if (this.formStatus === 422) {
          displayFormErrors(this.element, data.errorMessages || data);
          displayToast(this.element.dataset.errorMessage);
        }
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "PaymentSubscription", {
          response: this.response,
        });
      });
  }
}

const paymentSubscriptionElement = document.querySelector("[data-js='payment-subscription']");

if (paymentSubscriptionElement) {
  new PaymentSubscription(paymentSubscriptionElement);
}
